import React from 'react'

import cm from './Progress.module.css'

export const Progress = ({ current, total }: { current: number; total: number }) => (
  <div className={cm.progress}>
    <div
      className={cm.progress__line}
      style={{
        width: `${(current / total) * 100}%`,
      }}
    />
  </div>
)
